import { LucideIcon } from "lucide-react";

export function DataControlCard({
  icon: Icon,
  title,
  description,
  action,
}: {
  icon: LucideIcon;
  title: string;
  description: string;
  action: React.ReactNode;
}) {
  return (
    <div className="rounded-[24px] border border-white/10 bg-white/[0.035] p-5 backdrop-blur-xl">
      <div className="flex items-start gap-4">
        <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl bg-white/10 text-amber-100">
          <Icon size={18} />
        </div>

        <div className="min-w-0 flex-1">
          <h3 className="text-lg font-light tracking-[-0.04em] text-white">{title}</h3>
          <p className="mt-2 text-sm leading-6 text-white/48">{description}</p>
          <div className="mt-4">{action}</div>
        </div>
      </div>
    </div>
  );
}
